import React from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import store from "store";
import { Hooks } from "@xt/xtbase";
const { useIntl, FormattedMessage } = Hooks;
import stylesLess from "./index.module.less";
import axios from "utils/axios";
import cookie from "utils/cookie";
import sessionStorage from "utils/sessionStorage";
import { regexp, doRsaEncrypt, getAbsoluteUrl } from "utils/method";
import { get_loginBy2Fa } from "api/uaapi/uaa";
import { get_faCheckToken } from "api/uaapi/user";

import AntdModalAlert from "components/Antd/Modal/Alert";
import ButtonBig from "components/Antd/Button/big";
import Passcode from "components/App/Passcode";
import FormItem from "components/App/FormItem";
import FormItemInput from "components/App/FormItem/Input";
import FormItemPassword from "components/App/FormItem/Password";
import Geetest from "components/Geetest";
import Mode1 from "./Mode1";
import Mode2 from "./Mode2";
import { openLivehelp100Support } from "@/utils/livehelp100";

export default observer(function App2fa({ codeType, onSuccess, noDataCallback, hideVoiceVerification }) {
  const intl = useIntl();
  const router = useRouter();
  const { isDark } = store.app;
  const isSubAccount = router.asPath.includes("isSubAccount");
  React.useEffect(() => {
    const auth2fa = sessionStorage.get("2fa");
    // const auth2fa = {
    //   faResultId: "a98f24afcbfc49d8bf303893fe0cddb8",
    //   countryCode: "91",
    //   mobile: "18505516928",
    //   email: "544564339@gmail.com",
    //   faItems: [
    //     {
    //       validateItemType: 0,
    //       priority: 1,
    //     },
    //     {
    //       validateItemType: 1,
    //       priority: 1,
    //     },
    //     {
    //       validateItemType: 2,
    //       priority: 1,
    //     },
    //   ],
    // };
    console.log(auth2fa, "auth2fa");
    const faCheckId = auth2fa?.faCheckId ?? auth2fa?.faResultId;
    if (!auth2fa || !faCheckId) {
      if (noDataCallback) return noDataCallback();
      if (typeof location !== "undefined")
        location.replace(
          getAbsoluteUrl({
            pathname: "/login",
            locale: router.locale,
            query: router.query
          })
        );
      else
        router.replace({
          pathname: "/login",
          query: router.query
        });
      return;
    }
    // if (!auth2fa.faItems.length) {

    // }

    setState_2fa({ ...auth2fa, faCheckId: auth2fa.faCheckId ?? auth2fa.faResultId });

    return () => {
      sessionStorage.remove("2fa");
    };
  }, []);

  const [state_2fa, setState_2fa] = React.useState(null);
  React.useEffect(() => {
    if (!state_2fa) return;
    if (!state_2fa.faItems || !state_2fa.faItems.length) handleSubmit();
  }, [state_2fa]);
  const mode = React.useMemo(() => {
    if (!state_2fa || !state_2fa.faItems || !state_2fa.faItems.length) return 0;
    const { faItems } = state_2fa;
    if (faItems.length === 1) return 1;
    if (faItems[0].priority === faItems[1].priority) return 2;
    return 1;
  }, [state_2fa]);

  const [state_loading, setState_loading] = React.useState(false);
  const [state_btn_disabled, setState_btn_disabled] = React.useState(false);
  const [state_errMsg, setState_errMsg] = React.useState("");
  const handleSubmit = async (params = {}) => {
    if (state_loading || !state_2fa) return;
    setState_loading(true);
    setState_errMsg("");

    params.faCheckId = state_2fa.faCheckId ?? state_2fa.faResultId;
    //登陆是0，重置密码是13
    params.faBizType = codeType == 102 ? 13 : 0;
    const faCheckTokenRet = await axios.asyncAwait(get_faCheckToken, {
      params,
      errorPop: mode === 2
    });
    try {
      sensors.track("SecurityValidationResult", {
        code_type: "验证码",
        is_success: faCheckTokenRet.err ? false : true,
        fail_reason: faCheckTokenRet.err,
        service_type: codeType == 102 ? "忘记密码" : "登录"
      });
    } catch (error) {}

    setState_loading(false);

    if (faCheckTokenRet.err) {
      setState_errMsg(faCheckTokenRet.err);
      if (faCheckTokenRet.data.code === 1302) {
        router.back();
      }
      return;
    }
    onSuccess && onSuccess(faCheckTokenRet.data);

    /*
    const { err, data } = await axios.asyncAwait(
      get_loginBy2Fa,
      faCheckTokenRet.data.faResultId,
      {
        errorPop: true,
      }
    );

    setState_loading(false);
    if (err) return;

    onSuccess && onSuccess(data);
     */
  };

  const [state_email_more, setState_email_more] = React.useState(0);
  const handleNoReceiveCode = () => {
    const { email } = state_2fa;
    AntdModalAlert({
      isDark: isDark,
      title: intl.formatMessage({ id: "register.noReceiveCodeTipTitle" }),
      content: (
        <div>
          <div style={{ marginBottom: 16 }}>{intl.formatMessage({ id: "register.noReceiveCodeTipDesc" })}</div>
          <div style={{ marginBottom: 16 }}>{intl.formatMessage({ id: "register.noReceiveCodeTipStep1" })}</div>
          <div style={{ marginBottom: 16 }}>{intl.formatMessage({ id: "register.noReceiveCodeTipStep2" }, { 0: email })}</div>
          <div>{intl.formatMessage({ id: "register.noReceiveCodeTipStep3" })}</div>
        </div>
      )
    });
  };

  const mode1Ref = React.useRef();
  const mode2Ref = React.useRef();
  const handleSubmitBtn = () => {
    if (mode === 1) return mode1Ref.current.verify();
    if (mode === 2) return mode2Ref.current.verify();
  };

  const handleSecurityItemDisabled = () => {
    // 原：跳转 accounts/user/reset-verification
    // if (typeof window !== "undefined")
    //   window.location = `${domain}/${router.locale}/accounts/user/reset-verification?faCheckId=${state_2fa.faCheckId}&backUrl=${
    //     window.location.origin + window.location.pathname
    //   }`;
    if (typeof window !== "undefined") openLivehelp100Support();
  };

  return (
    <div className={`${stylesLess.main} ${isDark ? "dark" : "light"}`}>
      <div className="iHead">
        <FormattedMessage id="app.2fa" />
      </div>
      <div className={"iForm"}>
        {mode === 1 && (
          <Mode1
            ref={mode1Ref}
            fa={state_2fa}
            codeType={codeType}
            disabled={state_loading}
            errMsg={state_errMsg}
            onSubmit={handleSubmit}
            update_btn_disabled={setState_btn_disabled}
            hideVoiceVerification={hideVoiceVerification}
          />
        )}
        {mode === 2 && (
          <Mode2
            ref={mode2Ref}
            fa={state_2fa}
            codeType={codeType}
            disabled={state_loading}
            errMsg={state_errMsg}
            onSubmit={handleSubmit}
            update_email_more={() => setState_email_more(state_email_more + 1)}
            hideVoiceVerification={hideVoiceVerification}
          />
        )}

        {!(mode === 1 && state_2fa && state_2fa.faItems.length === 1) && (
          <ButtonBig
            className={"iBtn"}
            loading={state_loading}
            // disabled={state_btn_disabled}
            onClick={handleSubmitBtn}
          >
            <FormattedMessage id="app.confirm" />
          </ButtonBig>
        )}
        {!isSubAccount && (
          <div>
            <button className={"btntxt atv"} onClick={handleSecurityItemDisabled}>
              <FormattedMessage id="app.securityItemDisabled" />
            </button>
          </div>
        )}

        {state_email_more > 1 && (
          <div className={"iResend"} style={{ marginTop: 12 }}>
            <button className={"btntxt atv"} onClick={handleNoReceiveCode}>
              <FormattedMessage id="register.noReceiveCode" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
});
